<script>
import Search from "../components/Search.vue";
import OfferCreator from "../components/OfferCreator.vue";
import { mapMutations } from "vuex";
export default {
      name: "Navigation",
      components: { Search, OfferCreator },
      props: {
            user: {
                  type: Object,
                  required: true,
            },
      },
      data() {
            return {
                 logout_visible: false
            };
      },
      computed: {
            impersonating() {
                  return this.$store.state.impersonating;
            },
            // Droit d'impersonation = role de l'admin REEL (pas de l'utilisateur impersonate).
            realAdmin() {
                  const ref = this.$store.state.impersonating
                        ? this.$store.state.realUser
                        : this.$store.state.user;
                  return !!(ref && ref.role && ref.role.administrator);
            },
            realUserName() {
                  return this.$store.state.realUser ? this.$store.state.realUser.display_name : "";
            },
            commerciaux() {
                  return this.$store.state.commerciaux || [];
            },
      },
      methods: {
            handleLogOut() {
                  this.$store.commit("disconnect");
                  this.$router.push("/login");
            },
            impersonate(e) {
                  const id = e.target.value;
                  e.target.value = "";
                  if (!id) return;
                  const selected = this.commerciaux.find((c) => String(c.ID) === String(id));
                  if (!selected) return;
                  // On n'impersonate pas l'admin lui-meme.
                  if (selected.ID == this.$store.state.user.ID) return;
                  this.logout_visible = false;
                  this.$store.commit("startImpersonation", selected);
                  this.refreshAfterSwitch();
            },
            stopImpersonation() {
                  this.logout_visible = false;
                  this.$store.commit("stopImpersonation");
                  this.refreshAfterSwitch();
            },
            // Rafraichit les offres pour le nouvel utilisateur et revient au dashboard.
            refreshAfterSwitch() {
                  this.$store.dispatch("listeOffres").catch(() => {});
                  if (this.$route.path !== "/") {
                        this.$router.push("/").catch(() => {});
                  }
            },
            ...mapMutations(["mutate_createofferOpen"]),
      }
};
</script>
<template>
      <div id="header">
            <div class="container">
                  <div class="gauche">
                        <div class="logo">
                              <router-link to="/">
                                    <img src="../assets/logovertical.png" />
                              </router-link>
                        </div>
                        <div class="links">
                              <router-link class="main-links" to="/">
                                    <strong>Dashboard</strong>
                              </router-link>

                              <router-link class="main-links" to="/customers">
                                    <strong>Customers</strong>
                              </router-link>
                        </div>
                  </div>
                  <div class="droite">
                        <button id="new_offre" @click="mutate_createofferOpen(true)" v-if="$store.state.machines_ready"><i class="fal fa-plus"></i> Create new offer</button>
                        <Search />

                        <!-- Banniere d'impersonation (visible des qu'un admin "voit en tant que") -->
                        <div class="impersonation_banner" v-if="impersonating">
                              <i class="fal fa-user-secret"></i>
                              <span>Viewing as <strong>{{ user.display_name }}</strong></span>
                              <button class="exit_impersonation" @click="stopImpersonation()" title="Stop impersonation">
                                    <i class="fal fa-times"></i>
                              </button>
                        </div>

                        <div class="user_info" :class="{ is_impersonating: impersonating }" @mouseleave="logout_visible = false;">
                              <div class="avatar">
                                    <img loading="lazy" :src="user.avatar" @click="logout_visible = !logout_visible"/>
                              </div>
                              <div :class="`${logout_visible ? 'popup_user visible' : 'popup_user'}`">
                                    <div class="user_name">{{ this.$store.state.user.display_name }}</div>
                                    <div class="email">{{ this.$store.state.user.user_email }}</div>

                                    <!-- Impersonation : reserve aux administrateurs -->
                                    <div class="impersonation" v-if="realAdmin">
                                          <template v-if="impersonating">
                                                <div class="impersonation_label">Currently impersonating</div>
                                                <div class="impersonation_current">{{ user.display_name }}</div>
                                                <button class="stop_impersonation" @click="stopImpersonation()">
                                                      <i class="fal fa-undo"></i> Back to {{ realUserName }}
                                                </button>
                                          </template>
                                          <template v-else>
                                                <div class="impersonation_label">View as another user</div>
                                                <select class="impersonation_select" @change="impersonate">
                                                      <option value="" disabled selected>Select a user…</option>
                                                      <option
                                                            v-for="c in commerciaux"
                                                            :key="c.ID"
                                                            :value="c.ID"
                                                      >{{ c.display_name }} — ID {{ c.ID }}</option>
                                                </select>
                                          </template>
                                    </div>

                                    <button @click="handleLogOut()" class="logout">Logout</button>
                              </div>
                        </div>
                  </div>
            </div>
            <OfferCreator />
      </div>
</template>
<style lang="less">
#header {
      position: fixed;
      top: 0;
      width: 100%;
      background: white;
      z-index: 999;
      height: 64px;
      padding: 0 60px;
      font-family: "Inter var", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
      .container {
            widows: 100%;
            max-width: 1600px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .gauche {
                  flex: 1;
                  display: flex;
                  align-items: stretch;
                  gap: 40px;
                  .logo {
                        flex: 0 0 auto;
                        padding: 5px 0;
                        img {
                              height: 50px;
                        }
                  }
                  .links {
                        display: flex;
                        gap: 40px;
                        align-items: stretch;
                        a {
                              display: flex;
                              align-items: center;
                              border-bottom: solid 0px #88aabd;
                              transition: all .4s ease;
                              border-bottom: solid 2px transparent;
                              &:hover {
                                    border-bottom: solid 2px #88aabd;
                              }
                              &.router-link-exact-active {
                                    border-bottom: solid 2px #f18b00;
                              }
                              strong {
                                    font-weight: 500;
                                    font-size: 0.875rem;
                              }
                        }

                  }
            }
            .droite {
                  flex: 0 0 auto;
                  display: flex;
                  align-items: center;
                  gap: 20px;
                  #new_offre {
                        font-weight: 600;
                        font-size: 0.875rem;
                        cursor: pointer;
                        line-height: 1.25rem;
                        background: #f18b00;
                        color: white;
                        border: none;
                        outline: none;
                        padding-top: 0.5rem;
                        padding-bottom: 0.5rem;
                        padding-left: 1rem;
                        padding-right: 1rem;
                        border-radius: 5px;
                        column-gap: 0.375rem;
                        display: inline-flex;
                        align-items: center;
                        transition: all .4s ease;
                        
                        &:hover {
                              background: darken(#f18b00, 10%);
                        }
                  }
                  .impersonation_banner {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        background: #fff4e5;
                        border: solid 1px #f18b00;
                        color: #b35f00;
                        font-size: 0.8rem;
                        font-weight: 600;
                        padding: 6px 6px 6px 12px;
                        border-radius: 20px;
                        white-space: nowrap;
                        i {
                              font-size: 1rem;
                        }
                        strong {
                              font-weight: 700;
                        }
                        .exit_impersonation {
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              width: 24px;
                              height: 24px;
                              border: none;
                              border-radius: 50%;
                              background: #f18b00;
                              color: white;
                              cursor: pointer;
                              transition: all .3s ease;
                              i { font-size: .85rem; }
                              &:hover { background: darken(#f18b00, 12%); }
                        }
                  }
                  .user_info {
                        position: relative;
                        &.is_impersonating .avatar {
                              border-color: #f18b00;
                              box-shadow: 0 0 0 2px #f18b00;
                        }
                        .avatar {
                              border-radius: 50px;
                              overflow: hidden;
                              width: 44px;
                              height: 44px;
                              border: solid 1px rgb(0 0 0 / 10%);
                              padding: 2px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              img {
                                    width: 40px;
                                    height: 40px;
                                    object-fit: cover;
                              }
                        }
                        .popup_user {
                              position: absolute;
                              top: 100%;
                              right: -20px;
                              background: white;
                              border-radius: 15px;
                              box-shadow: 0 0 10px rgb(0 0 0 / 10%);
                              padding: 20px;
                              display: none;
                              z-index: 999;
                              width: min-content;
                              .user_name {
                                    font-weight: 600;
                                    font-size: 0.875rem;
                                    line-height: 1.25rem;
                                    color: #111827;
                              }
                              .email {
                                    font-size: 0.75rem;
                                    line-height: 1rem;
                                    color: #6B7280;
                                    padding-bottom: 20px;
                              }
                              .impersonation {
                                    width: 100%;
                                    border-top: solid 1px #e5e7eb;
                                    padding: 16px 0;
                                    margin-bottom: 12px;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: stretch;
                                    gap: 8px;
                                    text-align: left;
                                    .impersonation_label {
                                          font-size: 0.7rem;
                                          text-transform: uppercase;
                                          letter-spacing: 0.04em;
                                          color: #9CA3AF;
                                          font-weight: 600;
                                    }
                                    .impersonation_current {
                                          font-size: 0.875rem;
                                          font-weight: 600;
                                          color: #b35f00;
                                    }
                                    input[type="text"],
                                    .impersonation_select {
                                          width: 100%;
                                          min-width: 200px;
                                          height: 36px;
                                          border: solid 1px #d1d5db;
                                          border-radius: 8px;
                                          padding: 0 12px;
                                          font-size: 0.85rem;
                                          background: white;
                                          cursor: pointer;
                                          outline: none;
                                          transition: all .3s ease;
                                          &:focus {
                                                border-color: #f18b00;
                                                box-shadow: 0 2px 10px fadeOut(#f18b00, 70%);
                                          }
                                    }
                                    .stop_impersonation {
                                          display: inline-flex;
                                          align-items: center;
                                          justify-content: center;
                                          gap: 6px;
                                          cursor: pointer;
                                          border: solid 1px #f18b00;
                                          background: #f18b00;
                                          color: white;
                                          font-weight: 600;
                                          font-size: 0.8rem;
                                          padding: 8px 12px;
                                          border-radius: 8px;
                                          transition: all .3s ease;
                                          &:hover { background: darken(#f18b00, 12%); }
                                    }
                              }
                              .logout {
                                     -webkit-text-size-adjust: 100%;
                                    tab-size: 4;
                                    -webkit-tap-highlight-color: transparent;
                                    -webkit-font-smoothing: antialiased;
                                    box-sizing: border-box;
                                    border-width: 0;
                                    border-style: solid;
                                    border-color: #e5e7eb;
                                    font-family: inherit;
                                    font-feature-settings: inherit;
                                    font-variation-settings: inherit;
                                    margin: 0;
                                    text-transform: none;
                                    cursor: pointer;
                                    -webkit-appearance: button;
                                    background-image: none;
                                    border-radius: 0.375rem;
                                    background-color: rgb(255 255 255 / 1);
                                    padding-left: 0.75rem;
                                    padding-right: 0.75rem;
                                    padding-top: 0.5rem;
                                    padding-bottom: 0.5rem;
                                    font-size: 0.875rem;
                                    line-height: 1.25rem;
                                    font-weight: 600;
                                    color: rgb(17 24 39 / 1);
                                    box-shadow: rgb(255, 255, 255) 0px 0px 0px 0px inset, rgb(209, 213, 219) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
                                    &:hover {
                                          box-shadow: rgb(255, 255, 255) 0px 0px 0px 0px inset, #f18b00 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
                                    }
                              }
                              &.visible {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;
                                    gap: 4px;
                              }
                        }
                  }
            }
      }
}
</style>